import styles from "./classes.css";
console.info("CLASSES STY", styles);
// eslint-disable-next-line kf/const-naming-convention
export const Classes = styles;
